import { Component, Inject, OnInit } from '@angular/core';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { UserSessionService } from 'bna-angular-auth-client';
import { OrganizationResult } from 'src/app/shared/models/agency-mgmt/manager.service.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationDetailsService } from 'src/app/shared/Services/organization-details.service';

@Component({
  selector: 'app-switch-organization',
  templateUrl: './switch-organization.component.html',
  styleUrls: ['./switch-organization.component.scss'],
})
export class SwitchOrganizationComponent implements OnInit {
  organizations: OrganizationResult[] = [];
  modalPopup = false;
  switching = false;
  private selectedOrganizationId: string;

  constructor(
    private toasterService: TosterService,
    private organizationService: OrganizationService,
    private userSessionService: UserSessionService,
    private organizationDetailService: OrganizationDetailsService,
    @Inject(MAT_DIALOG_DATA) public modalData: { modalPopup: boolean },
    public dialogRef: MatDialogRef<SwitchOrganizationComponent>
  ) {
    if (this.modalData) this.modalPopup = modalData.modalPopup;
  }

  ngOnInit() {
    this.organizationService.getList().subscribe((organizations) => {
      if (organizations?.length < 2) return;
      this.organizations = organizations;
    });

    this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!result.isAuthenticated) return;
      this.selectedOrganizationId =
        this.userSessionService.getProfile().organizationId;
    });
  }

  switch(id: string) {
    this.switching = true;
    this.userSessionService.switchOrganization(id).subscribe((_) => {
      this.closeDialog();
      this.switching = false;
      this.toasterService.success('Organization switched');
      this.organizationDetailService.setupOrgainzationData();
    });
  }

  private closeDialog() {
    if (!this.modalData?.modalPopup) return;
    this.dialogRef.close();
  }

  public isCurrentOrganization(org: OrganizationResult) {
    return this.selectedOrganizationId == org.id;
  }
}
